import React, { useState, useEffect } from "react";
import axios from 'axios';
import Carousel from "react-simply-carousel";
import Image from "next/image";
import IMAGES from "@/public/assets/img";
import homeSliderStyle from '../../styles/Home.module.css';
import Link from 'next/link'
import { ENDPOINTS, WEB_URL } from "@/config/endpoints";



const HomeSliderSwiper =()=> {
  const [activeSlide, setActiveSlide] = useState(0);

  const [posts, setPosts] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);


  useEffect(() => {
    const fetchPosts = async () => {
      try{
        const res = await axios.get(ENDPOINTS.WORDPRESS_BLOG_POST_LIST_WITH_IMAGE + `&page=${currentPage}&per_page=8`);
        setPosts(res.data);
        const totalPosts = res.headers['x-wp-total'];
          const totalPages = res.headers['x-wp-totalpages'];
          setTotalPages(parseInt(totalPages));
      } catch (error) {
        console.error('Error:', error);
      }
     
    };

    fetchPosts();
    
  }, []);

  const dateFormat = (publishDate)=>{
    const dateString = new Date(publishDate);
    const options = { day:'numeric', year: 'numeric', month: 'long' };
    if (typeof dateString === 'object' && dateString !== null && 'toLocaleDateString' in dateString) {
      const result = dateString.toLocaleDateString('en-US',options);
      return <span>{result}</span>
    }
    
  }
  const truncateString=(str, maxLength)=> {
    if (str.length <= maxLength) {
      return str; // No truncation needed
    }
  
    // Truncate the string and append an ellipsis
    const truncatedString = str.slice(0, maxLength - 3) + '...';
    return truncatedString;
  }
  const truncatedTitle=(title)=>{
    const originalString = title;
    const maxLength = 60;
    return truncateString(originalString, maxLength);
  }

  const toTitleCase = (str) => {
    return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
      <section className="py-20 sm:py-[40px]">
        <div className="container xm:px-2 px-3">
            <h4 className="text-xxl text-secondary pb-6 sm:pb-5 text-center font-medium">Keep Up with the Latest on Credlix</h4>
            <div className={`${homeSliderStyle.homesimpleslider}`}>
            <Carousel
                containerProps={{
                style: {
                    width: "100%",
                    maxWidth: "95%",
                    height:"100%",
                    margin: "0 auto",
                    justifyContent: "space-between",
                    userSelect: "none",
                    position:"relative",
                    justifyContent:"center",

                }
                }}
                preventScrollOnSwipe={true}
                swipeTreshold={60}
                activeSlideIndex={activeSlide}
                onRequestChange={setActiveSlide}
                forwardBtnProps={{
                children: ">",
                "aria-label": "Next slide",
                style: {
                    width: 26,
                    height: 26,
                    minWidth: 26,
                    position:"absolute",
                    background:"#022b5c",
                    color:"#FFFFFF",
                    borderRadius: "50%",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                    right:"-35px",
                    zIndex:10,
                    bottom:"50%"

                }
                }}
                backwardBtnProps={{
                children: "<",
                "aria-label": "Previous slide",
                style: {
                    width: 26,
                    height: 26,
                    minWidth: 26,
                    position:"absolute",
                    background:"#022b5c",
                    color:"#FFFFFF",
                    borderRadius: "50%",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                    left:"-35px",
                    zIndex:10,
                    bottom:"50%"
                }
                }}
                responsiveProps={
                    [{minWidth: 768, maxWidth: 992, itemsToShow: 3}, 
                    {maxWidth: 767, itemsToShow: 2},{maxWidth: 500, itemsToShow: 2}]
                }
                // dotsNav={{
                // show: true,
                // itemBtnProps: {
                //     style: {
                //     height: 14,
                //     width: 14,
                //     borderRadius: "50%",
                //     border: 0,
                //     background:"#C1CAD6",
                //     margin:"0 5px",
                //     }
                // },
                // activeItemBtnProps: {
                //     style: {
                //     height: 16,
                //     width: 16,
                //     borderRadius: "50%",
                //     border: 0,
                //     background: "#022b5c",
                //     margin:"0 5px",
                //     }
                // }
                // }}
                itemsToShow={4}
                speed={400}
                easing="linear"
            >
                 {posts.map((post) => (
                    <div key={post.id}>
                        <div className="w-[300px] sm:w-[270px] mb-[30px] mx-2 rounded-lg shadow-shadow-slider">
                            <Link href={WEB_URL+`/blogs/${post.slug}`} rel="noopener noreferrer">
                                {post._embedded && post._embedded['wp:featuredmedia'] && (
                                    <Image className='w-full h-auto sm:h-auto rounded-tl-lg rounded-tr-lg'
                                    style={{ width: "auto", height: "auto" }} 
                                        src={post._embedded['wp:featuredmedia'][0].source_url}
                                        alt={post.title.rendered} width={261} height={180}
                                    />
                                )}
                                <div className="px-2 pt-4">
                                    <p className='text-xs text-[#595959]'>{dateFormat(post.date)}</p>
                                    <h3 className="text-sm text-secondary my-1 mb-3 min-h-[40px]" dangerouslySetInnerHTML={{ __html: truncatedTitle(post.title.rendered) }} />
                                    <div className='flex items-end justify-between mb-1'>
                                    <span className="flex items-center text-brand text-xs">
                                        Read More
                                        <span className="ml-1">
                                        <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18"><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" fill="rgba(2,43,92,1)"></path>
                                        </svg>
                                        </span>
                                    </span>
                                </div>
                                </div>
                                {/* <h3 className="text-sm text-secondary font-normal px-2 pt-4 min-h-[120px] sm:min-h-[70px] bg-white">{SliderData.heading}</h3> */}
                            </Link>

                            {post._embedded && post._embedded['wp:term'] && (
                                <div className='pb-3 px-2'>
                                    {post._embedded['wp:term'][0].map(category => (
                                        category.name != 'Blog' &&
                                        <Link key={category.id} className='text-[12px] text-brand bg-[#ddd] rounded-md py-[3px] px-[5px] mr-1 hover:underline' href={WEB_URL+`/blogs/category/${category.id}/${category.slug}`}>{toTitleCase(category.name)}</Link>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                 ))}
            </Carousel>
            </div>
        </div>
    </section>
  );
}

export default  HomeSliderSwiper;
